// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"OLparser","644":"BufferOp"}[chunkId] || chunkId) + ".bundle.js";
};